import moment from 'moment';

import template from './status-check.html';

const preCheckList = {
  communicatedAt: {
    key: 'communicatedAt',
    name: 'Communication',
    class: 'fa-exchange',
    status: '',
    bad: 'No communication has been made with the equipment in the last 2 hours',
    good: 'In good communication status',
    getStatus: (comAt) => {
      return (comAt && moment().diff(moment(comAt), 'hours')) > 2 ? 'bad' : 'good';
    },
  },
  battery: {
    key: 'battery',
    name: 'Battery Status',
    class: 'fa-battery-full',
    status: '',
    bad: 'Battery voltage is low.',
    good: 'Battery voltage is good.',
    getStatus: (series) => {
      const v = series['battery_potential']?.last?.v;
      return v > 10 ? 'good' : 'bad';
    },
  },
  auto_mode: {
    key: 'auto_mode',
    name: 'Remote Start Setting',
    class: 'fa-key',
    status: '',
    bad: 'Please make sure Autostart setting is in the Keypad Start position and the Controller Mode is in the Auto mode ',
    good: 'The Autostart Setting is in the Keypad Start position and the Controller Mode is in the Auto mode ',
    getStatus: (series) => {
      const autoSetting = series['auto_start_mpc']?.last?.v;
      const ctrlMode = series['controller_mode_mpc_pump']?.last?.v;
      //255 = auto, 1=Remote Start
      return ctrlMode === 255 && autoSetting === 1 ? 'good' : 'bad';
    },
  },
};

class StatusCheckController {
  constructor(dashboardCommandsService) {
    'ngInject';

    this.commandService = dashboardCommandsService;

    this.preCheck = preCheckList;
  }

  toggleMsg(key) {
    this.checked = this.checked?.key !== key ? this.preCheck[key] : undefined;
  }

  $onInit() {}

  $onChanges() {
    Object.keys(this.preCheck).forEach((key) => {
      if (key === 'communicatedAt') {
        this.preCheck[key].status = this.preCheck[key].getStatus(this.communicatedAt);
      } else {
        this.preCheck[key].status = this.preCheck[key].getStatus(this.series);
      }
    });
  }

  $onDestroy() {}
}

export default {
  template,
  controller: StatusCheckController,
  controllerAs: 'vm',
  bindings: {
    series: '<',
    communicatedAt: '<',
  },
};
